import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import CancelIcon from '@material-ui/icons/HighlightOff';
import {FileInput, TabPanel} from '../../../FlowConfigurationInputs';
import {CredentialPicker} from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function SendMail({action, variables, setOpenVariable}) {

    const {t} = useTranslation();
    const [attachments, setAttachments] = useState(action.fields.attachments?.value ? action.fields.attachments.value : [{tab: 'browse'}])
    const label = 'CONTENT.CONFIGURATION-FORM.EMAIL.SEND-MAIL.';

    useEffect(() => {
        if (!action.fields.attachments) {
            action.fields.attachments = {value: [{tab: 'browse'}], type: 'ATTACHMENTS'};
        }
    }, []);
    const handleChange = (newValue, item) => {
        item.tab = newValue;
        if (newValue === 'browse') {
            delete item.variable;
        } else if (newValue === 'variable') {
            delete item.browse;
        }
        setAttachments([...attachments]);
    };
    const handleAdd = () => {
        const newValue = [...attachments, {tab: 'browse'}];
        action.fields.attachments = {value: newValue, type: 'ATTACHMENTS'};
        setAttachments(newValue);
    }
    const handleDelete = (itemI) => {
        attachments.splice(itemI, 1);
        action.fields.attachments = {value: attachments, type: 'ATTACHMENTS'};
        setAttachments([...attachments]);
    }
    return (
        <>
            <div className="form-element">
                {t(label + 'HOST')}
                <TextInput action={action} inputName="host" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired fieldType="string" displayName={t(label + 'HOST')}/>
            </div>
            <div className="form-element">
                {t(label + 'PORT')}
                <TextInput action={action} inputName="port" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired fieldType="number" displayName={t(label + 'PORT')}/>
            </div>
            <div className="form-element">
                {t(label + 'USERNAME')}
                <CredentialPicker action={action} inputName="userName" variables={variables}
                                  setOpenVariable={setOpenVariable} isRequired/>
            </div>
            <div className="form-element">
                {t(label + 'PASSWORD')}
                <CredentialPicker action={action} inputName="password" variables={variables}
                                  setOpenVariable={setOpenVariable} isRequired isPassword={true}/>
            </div>
            <div className="form-element">
                {t(label + 'FROM')}
                <TextInput action={action} inputName="from" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired fieldType="string" displayName={t(label + 'FROM')}/>
            </div>
            <div className="form-element">
                {t(label + 'SENDER-NAME')}
                <TextInput action={action} inputName="senderName" variables={variables}
                           setOpenVariable={setOpenVariable} isRequired fieldType="string" displayName={t(label + 'SENDER-NAME')}/>
            </div>
            <div className="form-element">
                {t(label + 'TO')}
                <TextInput action={action} inputName="to" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired fieldType="string" displayName={t(label + 'TO')}/>
            </div>
            <div className="form-element">
                {t(label + 'CC')}
                <TextInput action={action} inputName="cc" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'CC')}/>
            </div>
            <div className="form-element">
                {t(label + 'SUBJECT')}
                <TextInput action={action} inputName="subject" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired fieldType="string" displayName={t(label + 'SUBJECT')}/>
            </div>
            <div className="form-element">
                {t(label + 'ATTACHMENTS')} &nbsp;
                {attachments.map((item, itemI) => {
                    return (
                        <div key={itemI} style={{marginBottom: 10}}>
                            <div style={{display: 'flex'}}>
                                <div className="condition-tabs form-element">
                                    <button className={`col-4 ${item.tab === 'browse' ? 'condition-active' : ''}`}
                                            value="browse" onClick={() => handleChange("browse", item)}>
                                        Browse
                                    </button>
                                    <button className={`col-4 ${item.tab === 'variable' ? 'condition-active' : ''}`}
                                            value="variable" onClick={() => handleChange("variable", item)}>
                                        Variables
                                    </button>
                                    <CancelIcon onClick={() => {
                                        handleDelete(itemI);
                                    }} style={{paddingRight: 5, float: 'right', cursor: 'pointer'}}/>
                                </div>
                            </div>
                            <TabPanel value={item.tab} index={'browse'}>
                                <FileInput action={item} inputName="browse" isSize/>
                            </TabPanel>
                            <TabPanel value={item.tab} index={'variable'}>
                                <TextInput action={item} inputName="variable" variables={variables}
                                           setOpenVariable={setOpenVariable}/>
                            </TabPanel>
                        </div>
                    )
                })}
                <Button onClick={handleAdd}
                        style={{border: "none", color: "#8F94A6", fontWeight: 700, textTransform: "none"}}>
                    <AddIcon style={{paddingRight: 5}}/>{t(label + 'ADD')}
                </Button>
            </div>
            <div className="form-element">
                {t(label + 'BODY')}
                <TextInput type="html" action={action} inputName="body" variables={variables} setOpenVariable={setOpenVariable}
                           multiline fieldType="string" displayName={t(label + 'BODY')}/>
            </div>
        </>
    );
}

export default SendMail;
